// @ts-strict-ignore
import React from 'react'
import { useTheme } from 'styled-components/native'
import { useNavigation } from '@react-navigation/native'

import { handleNavigationContactInfo } from 'APP/Helpers/handleNavigationContactInfo'
import Config from 'APP/Config'
import Icon from 'APP/Converse/Icon'

import { getAnalyticsScreenName } from '../utils'
import { ServiceGroupCard } from '../ServiceGroupCard'
import { Images } from 'APP/Themes'

export const ContactInfoGroupCard = ({
  serviceGroup,
  contactInfo,
}: {
  serviceGroup: Record<string, unknown>
  contactInfo: { id: string; name: string; cardText: string; cardCallToAction: string }
}) => {
  const theme = useTheme()
  const navigation = useNavigation()
  const analyticsScreenName = getAnalyticsScreenName(serviceGroup)
  const { id, name } = contactInfo || {}
  const onPress = () => {
    handleNavigationContactInfo(contactInfo, navigation)
  }

  // Conditional icon rendering based on brand version
  const renderIcon = () => {
    if (Config.BRAND_VERSION === 'v2' && Config.BRAND_ID === 'sunlife') {
      return (
        <Images.call
          variant="svg"
          fillLine={theme.colors.primary}
          width={theme.metrics.icon.xsmall}
          height={theme.metrics.icon.xsmall}
        />
      )
    }

    return (
      <Icon
        src="help-outline"
        variant="materialIcons"
        color="accent"
        size={theme.metrics.icon.xsmall}
      />
    )
  }

  return (
    <ServiceGroupCard
      onPress={onPress}
      testID="CONTACT_INFO"
      analyticsName="contactInfo"
      icon={renderIcon()}
      cardText={contactInfo.cardText}
      callToAction={contactInfo.cardCallToAction}
      analyticsScreenName={analyticsScreenName}
      trackEventValue={`showContactInfo : ${id} : ${name}`}
      trackEventText="Show Contact Info"
    />
  )
}
